import React, { useContext } from 'react';
import { FlowContext } from '../../core/flow-engine';
import { contactTextFn } from '../../flows/shared/utils';
import { MFBeaconButton } from '../Beacon/BeaconComponents';
import styles from './styles.css';
import { isProd } from '../../config';

const RolloverConfirmation = ({ custodianName }) => {
  const { next } = useContext(FlowContext);
  const rolloverTimeTradeLink = isProd()
    ? 'https://trpii.my.site.com/scheduler/s?params=So7zAAT2gkfg6rrCoCmOGlHXoFFd0zyqQpmGMrSpIc8UVJM0%2FTeNFkxqEE51TEgzJ7P031I6g21mUfyMdP7O3%2FXePm8rUh3qEA7loR35AlrooI1LRPajRINDeL0hSz7hx4yGUVlauQ7KtdIPmtxVgA%3D%3D&flowName=GenerateInvitation'
    : 'https://trpii--qual.sandbox.my.site.com/scheduler/s?params=UtNAvJnjFqQ7vFtSBHKMPZ1U3Rlq4tj8NfwuTKGsCisFbW4CcpqQoYrRQ4WxOeaSxMh%2BUYhnhXcjkBpN2J2FELBc%2FYWetYQuPOsI8k%2FjjThV1cfK51x2Ck%2FWOaaSUT6rCmaPJUcgpApBxlBUYE8qAA%3D%3D&flowName=GenerateInvitation';

  return (
    <>
      <section className="next-instructions">
        <div className="step-contents">
          <h3>Complete your rollover</h3>
          <p>
            Everything is set on our end. Please call {custodianName} to request
            the rollover so we can complete the process. There are two ways to
            do so.
          </p>
          <p>
            <div className="option-text">
              Option 1: Contact {custodianName} with us
            </div>
            An associate from our rollover assistance team will be happy to help
            you. Schedule an appointment, or call now.
          </p>
          <p>
            <div className="qv-row">
              <div className="qv-col">
                <div>
                  <a
                    href={rolloverTimeTradeLink}
                    id="scheduleCallLink"
                    target="_blank"
                    rel="noopener noreferrer">
                    Schedule a call
                  </a>
                </div>
                <div>Plan for about 30 minutes</div>
              </div>
              <div className="qv-col">
                <div>
                  <a
                    href={`tel:${contactTextFn('rolloverCallAssistancePhone')(
                      0
                    )}`}>
                    Call now: {contactTextFn('rolloverCallAssistancePhone')(0)}
                  </a>
                </div>
              </div>
            </div>
          </p>
          <hr />
          <p>
            <div className="option-text">Option 2: Call on your own</div>
            Refer to this helpful guide when contacting {custodianName} on your
            own.
          </p>
          <p>
            <div>
              <MFBeaconButton
                id="rolloverGuideBtn"
                onClick={next('guide')}
                variant="tertiary"
                label="Rollover guide"
              />
            </div>
          </p>
        </div>
      </section>
      <style jsx>{styles}</style>
    </>
  );
};

export default RolloverConfirmation;
